export const maxMobileScreenWidth = 768;
export const maxTabletScreenWidth = 1024;
export const toastLength = 6000;
export const savedIndicatorLength = 6000;
export const savedNoteLength = 4000;
export const city = "Brooklyn";
export const address = "109 Montague St";
